var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33342 15C9.81256 14.9997 11.2491 14.5045 12.4142 13.5933L16.0776 17.2566L17.2559 16.0783L13.5926 12.415C14.5042 11.2497 14.9997 9.81282 15.0001 8.33329C15.0001 4.65746 12.0092 1.66663 8.33342 1.66663C4.65758 1.66663 1.66675 4.65746 1.66675 8.33329C1.66675 12.0091 4.65758 15 8.33342 15ZM8.33342 3.33329C11.0909 3.33329 13.3334 5.57579 13.3334 8.33329C13.3334 11.0908 11.0909 13.3333 8.33342 13.3333C5.57591 13.3333 3.33341 11.0908 3.33341 8.33329C3.33341 5.57579 5.57591 3.33329 8.33342 3.33329Z",
    fill: "#959BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.50408e0084a511dfc7c88075d01b7a57.svg";
export { ForwardRef as ReactComponent };